import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import { useCallback } from 'react';
import ExportDeletedWorkPlanCsvModal from './ExportDeletedWorkPlanCsvModal';

const useExportDeletedWorkPlanCsvModal = () => {
  const { openModal } = useDynamicModal();

  const openExportDeletedWorkPlanCsvModal = useCallback(
    ({ teamId }: { teamId: number }) => {
      openModal({
        modal: ({ isOpen, toggle }) => {
          return (
            <ExportDeletedWorkPlanCsvModal
              closeModal={toggle}
              selectedTeamId={teamId}
              isOpen={isOpen}
            />
          );
        },
      });
    },
    [openModal],
  );

  return { openExportDeletedWorkPlanCsvModal };
};

export default useExportDeletedWorkPlanCsvModal;
